import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { Reveal } from "../components/Reveal";
import OrderPipeline from "../components/OrderPipeline";

export default function TrackOrder() {
  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setOrder(null);
    try {
      const { data } = await api.get(`/orders/track/${encodeURIComponent(orderNumber.trim())}`, { params: { email } });
      setOrder(data);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-12 pt-32 pb-16" data-testid="track-page">
      <Reveal>
        <p className="eyebrow mb-3">Order tracking</p>
        <h1 className="font-display text-4xl md:text-5xl uppercase tracking-tight">Where's my gear</h1>
      </Reveal>
      <form onSubmit={submit} className="mt-10 grid sm:grid-cols-[1fr_1fr_auto] gap-3">
        <input data-testid="track-order-number-input" required value={orderNumber} onChange={(e) => setOrderNumber(e.target.value)} placeholder="ORDER NUMBER (CC-1001)" className="input-dark font-mono uppercase text-xs tracking-widest" />
        <input data-testid="track-email-input" required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="EMAIL" className="input-dark font-mono uppercase text-xs tracking-widest" />
        <button data-testid="track-submit-button" disabled={loading} className="btn-kinetic !px-6">{loading ? "…" : "Track"}</button>
      </form>
      {order && (
        <div className="mt-12 border border-white/10 bg-card p-6 md:p-8" data-testid="track-result">
          <div className="flex flex-wrap justify-between gap-4 mb-8">
            <div>
              <p className="font-mono text-xs uppercase tracking-widest text-zinc-500">Order</p>
              <p className="font-display text-2xl uppercase text-kinetic" data-testid="track-order-number">{order.order_number}</p>
            </div>
            <div className="text-right">
              <p className="font-mono text-xs uppercase tracking-widest text-zinc-500">Payment</p>
              <p className="font-mono text-sm uppercase text-zinc-200" data-testid="track-payment-status">{order.payment_status.replace("_", " ")}</p>
            </div>
          </div>
          <OrderPipeline status={order.status} />
          <div className="mt-8 space-y-3">
            {order.items.map((i, idx) => (
              <div key={idx} className="flex gap-3 items-center border border-white/10 p-3">
                <img src={i.image} alt="" className="w-12 h-14 object-cover" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-bold uppercase truncate">{i.name}</p>
                  <p className="font-mono text-[10px] text-zinc-500 uppercase">{i.size} / {i.color} × {i.qty}{i.customization?.text ? ` · “${i.customization.text}”` : ""}</p>
                </div>
                {i.customization?.artwork_path && (
                  <img src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${i.customization.artwork_path}`} alt="Custom artwork" className="w-10 h-10 object-contain border border-kinetic/40 bg-black" />
                )}
                <span className="font-mono text-xs">${(i.unit_price * i.qty).toFixed(2)}</span>
              </div>
            ))}
          </div>
          <div className="flex justify-between font-mono text-sm uppercase tracking-widest mt-6 pt-4 border-t border-white/10">
            <span className="text-zinc-400">Total</span>
            <span data-testid="track-order-total">${order.total.toFixed(2)}</span>
          </div>
        </div>
      )}
    </div>
  );
}
